import { createFileRoute } from "@tanstack/react-router";
import LoginPage from "@project/admin/pages/index";

export const Route = createFileRoute("/admin/")({
  head: () => ({ meta: [{ title: "Login — Jivandhara" }] }),
  component: LoginPage,
});
